export default __webpack_public_path__ + "static/shopify-e9d729c19956c9b0f2a7825f8d9bbc30.png";